(() => {
  let pending = false;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-addon-form]');
    if (!form) return;
    event.preventDefault();
    const drawer = document.querySelector('lux-cart-drawer');
    if (pending || drawer?.loading) return;
    const group = form.closest('[data-addons]');
    const status = group.querySelector('[data-addon-status]');
    const button = form.querySelector('button[type=submit]');
    const label = button.querySelector('[data-addon-label]');
    const original = label.textContent;
    const productId = form.closest('[data-offer-product]').dataset.offerProduct;
    const id = new FormData(form).get('id');
    if (!id) { form.reportValidity(); return; }
    pending = true;
    if (drawer) drawer.loading = true;
    button.disabled = true;
    label.textContent = group.dataset.busy;
    status.textContent = '';
    let added = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || group.dataset.error);
      added = true;
      // A full cart refresh keeps editable quantities and totals consistent.
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      document.querySelectorAll(`[data-offer-product="${productId}"]`).forEach(card => {
        card.hidden = true;
        const shelf = card.closest('[data-addons]');
        if (![...shelf.querySelectorAll('[data-offer-product]')].some(item => !item.hidden)) shelf.hidden = true;
      });
      status.textContent = group.dataset.added;
      await drawer?.refresh(true, group.dataset.context === 'drawer' ? drawer.openTrigger : document.querySelector('.lux-product__add'));
    } catch (error) {
      if (added) {
        // Never invite a duplicate add after the server has already accepted it.
        status.textContent = group.dataset.refreshError;
        const link = document.createElement('a');
        link.href = `${window.Shopify?.routes?.root || '/'}cart`;
        link.textContent = group.dataset.added;
        status.append(' ', link);
      } else {
        status.textContent = error.message || group.dataset.error;
        button.disabled = false;
        label.textContent = original;
      }
    } finally {
      pending = false;
      if (drawer?.isConnected) drawer.loading = false;
    }
  });
})();
